import { forwardRef } from 'react';
import { cn } from '@core/utils/cn';
import { Spinner } from './Spinner';
import { buttonVariants, type ButtonSize, type ButtonVariant } from './buttonVariants';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  readonly variant?: ButtonVariant;
  readonly size?: ButtonSize;
  readonly isLoading?: boolean;
  readonly fullWidth?: boolean;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { variant = 'primary', size = 'md', isLoading = false, fullWidth = false, className, children, disabled, ...props },
  ref,
) {
  return (
    <button
      ref={ref}
      className={cn(buttonVariants(variant, size), fullWidth && 'w-full', className)}
      disabled={disabled ?? isLoading}
      aria-busy={isLoading}
      {...props}
    >
      {isLoading && <Spinner size={16} />}
      {children}
    </button>
  );
});
